import { getGeoJson } from 'common/services/maps-api';
import { mapApiKey } from './config';
import { printViewportMap } from 'common/services/print-api';
import domToImage from 'dom-to-image-more';
import { lotStatusFilterInputs } from './filters';
import { getStatusColor } from './polygon';
import { usePrintEventStore } from '../store/useMapsStore';
export async function handleGetGeoJson(currentBrand, communityId) {
    try {
        const response = await getGeoJson(mapApiKey, currentBrand, communityId);
        const geoJson = await response.json();
        if (response.ok) {
            return geoJson.Features;
        }
        else {
            console.error('Problem with the Geo JSON request', response);
            return -1;
        }
    }
    catch (err) {
        console.error('Problem with getting the geo JSON by brand: ', err);
        return -1;
    }
}
export async function printMap(mapContainer, community, lots, lotStatusFilters, homeFilters) {
    return new Promise(async (resolve, reject) => {
        var scale = 2;
        const domToImageSettings = {
            width: mapContainer.clientWidth * scale,
            height: mapContainer.clientHeight * scale,
            quality: 0.9,
            style: {
                transform: "scale(" + scale + ")",
                transformOrigin: "top left"
            }
        };
        let mapScreenshotUrl = await domToImage.toJpeg(mapContainer, domToImageSettings);
        // To fix issues with ios being slow to load all the images, retry until the file size is realistic
        // Super hacky but it works
        for (let i = 0; i < 10; i++) {
            // When a blank background appears, the image size will be much smaller. Find a value that can determine whether the generation was successful
            if (mapScreenshotUrl.length / 1024 > 200) {
                break;
            }
            else {
                mapScreenshotUrl = await domToImage.toJpeg(mapContainer, domToImageSettings);
            }
        }
        // set state to remove secondary print map element from DOM
        usePrintEventStore.getState().setIsPrintMapRendering(false);
        const processedLotStatusFilters = lotStatusFilterInputs.map((lotStatusEntry) => {
            lotStatusEntry.checked = lotStatusFilters.includes(lotStatusEntry.value);
            return lotStatusEntry;
        });
        const mapRequest = {
            MapCanvasHtmlString: mapScreenshotUrl,
            Lots: lots,
            Community: community,
            LotStatusFilters: processedLotStatusFilters.map((statusFilter) => {
                statusFilter.checkboxColor = getStatusColor(statusFilter.value);
                return statusFilter;
            }),
            HomeFilters: homeFilters
        };
        try {
            const response = await printViewportMap(mapRequest);
            if (response.ok) {
                const pdfBlob = await response.blob();
                // thanks to https://stackoverflow.com/a/42274086/13931027
                // this will allow a PDF to be downloaded with a custom name
                // by appending a download link to a generic <a> element
                var url = window.URL.createObjectURL(pdfBlob);
                var a = document.createElement('a');
                a.href = url;
                a.download = community.Name ? (community.Name.replaceAll(' ', '_') + '.pdf') : "Century_Community.pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
                resolve();
            }
            else {
                reject('Failed API request' + response);
            }
        }
        catch (err) {
            reject(err);
        }
    });
}
